var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "function-card"
  }, _vm._l(_vm.list, function ({
    icon,
    title,
    desc
  }) {
    return _c("div", {
      key: title,
      staticClass: "list"
    }, [_c("img", {
      attrs: {
        src: icon,
        alt: ""
      }
    }), _c("h4", [_vm._v(_vm._s(title))]), _vm._l(desc, function (item, index) {
      return _c("p", {
        key: index
      }, [_vm._v(_vm._s(item))]);
    })], 2);
  }), 0);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };